export enum KocAilemSorguTipi {
  TCKN = 'TCKN',
  KARTNO = 'KARTNO',
  ALTINKOD = 'ALTINKOD',
}
